export const rejectRentalPropertyValidation = {
  comment: [{ required: true, message: 'Comment is required!' }],
};
